"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BgLocalArrayPushComponentParameters = void 0;
exports.BgLocalArrayPushComponentParameters = [
    {
        id: 'source',
        label: 'Source Element',
        description: 'Input Param - The element to be added to the array.',
        type: 'list',
        paramType: 'ANY',
        required: true,
    },
    {
        id: 'output',
        label: 'Output Array',
        description: 'Output Param - The array updated after pushing the element.',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
];
//# sourceMappingURL=BgLocalArrayPushComponent.js.map